import type { IconProps } from './IconProps';

export const ShieldTickIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 18}
    height={props.height ?? 18}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.78543 0.816201C8.92771 0.795641 9.0722 0.795641 9.21448 0.816201C9.37845 0.839895 9.53103 0.897536 9.65218 0.943304L9.68465 0.955539L13.804 2.50018C14.2673 2.67317 14.6742 2.82509 14.9876 3.10125C15.2617 3.34284 15.4729 3.64756 15.6028 3.98907C15.7514 4.37945 15.7508 4.81379 15.7501 5.30837L15.75 8.99978C15.75 11.1198 14.597 12.8872 13.3507 14.1856C12.096 15.4927 10.6605 16.4159 9.90138 16.8588L9.87064 16.8768C9.73212 16.9581 9.55233 17.0637 9.31448 17.1147C9.11988 17.1564 8.88003 17.1564 8.68543 17.1147C8.44759 17.0637 8.26779 16.9581 8.12927 16.8768L8.09853 16.8588C7.33945 16.4159 5.90392 15.4927 4.64925 14.1856C3.40292 12.8872 2.24995 11.1198 2.24995 8.99978L2.24985 5.30838C2.24914 4.8138 2.24851 4.37946 2.39706 3.98907C2.52701 3.64756 2.73819 3.34284 3.01232 3.10125C3.32569 2.82509 3.73259 2.67317 4.19594 2.50018L8.31526 0.95554L8.34773 0.943305C8.46888 0.897536 8.62146 0.839895 8.78543 0.816201ZM12.1553 7.28021C12.4482 6.98732 12.4482 6.51244 12.1553 6.21955C11.8624 5.92665 11.3875 5.92665 11.0946 6.21955L8.24994 9.06422L7.28027 8.09455C6.98738 7.80165 6.5125 7.80165 6.21961 8.09455C5.92672 8.38744 5.92672 8.86232 6.21961 9.15521L7.71961 10.6552C8.0125 10.9481 8.48738 10.9481 8.78027 10.6552L12.1553 7.28021Z"
      fill="#3EBE6A"
    />
  </svg>
);
